import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { OfbizField, OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';

@Component({
  selector: 'ubs-edit-summary',
  templateUrl: './edit-summary.component.html',
  styleUrls: ['./edit-summary.component.scss']
})
export class EditSummaryComponent implements OnInit {
  @Input() summaryData:any;
  @Input() formGroupName: string;
  @Input() ofbizForm:OfbizForm;
  @Input() fields:OfbizField[];
  initialState = "view";
  form: FormGroup;
  hasChanged:boolean = false;

  @Output() summarySubmit = new EventEmitter<string>();

  constructor(private rootFormGroup: FormGroupDirective) { }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    this.onChanges();
  }

  onChanges(){
    this.form.valueChanges.subscribe(data => {
      this.hasChanged = true;
      //console.log("Has changed tracked by valueChanges....");
    });
  }


  submit(){
    this.summarySubmit.emit(this.form.value); 
  }
  reset(){
    this.form.get("summaryData").setValue(this.summaryData);
  }

}
